<script>
  import { getContext } from 'svelte';
  import { format } from 'svelte-i18n';
  import { link } from 'svelte-navigator';

  import { DomainSwitcher } from '@client/components/domain-switcher';
  import { Icon } from '@client/components/icon';

  import { userStore } from '@client/stores/user';

  const { basepath } = getContext('config');

  export let domain = null;

  $: redirectUrl = $userStore.isStaff ? `${basepath}/staff/domains?search=${domain}` : `${basepath}/manage/domains`;
  $: canSwitchDomains = $userStore?.domaincount >= 1 || $userStore?.isStaff;
</script>

<div class="managing">
  <div>
    <a href={redirectUrl} use:link>
      <Icon name="eye" />
      {$format('label.MANAGING')}
    </a>
    {#if !canSwitchDomains}
      <strong data-testid="managing-domain">{domain}</strong>
    {:else}
      <DomainSwitcher variant="managing" caret nav>
        <span slot="toggle" data-testid="managing-domain">{domain}</span>
      </DomainSwitcher>
    {/if}
  </div>
</div>

<style lang="scss" src="./managing.scss"></style>
